/**
 * Modelo que representa un agente de IA en la aplicación
 */
class Agent {
  /**
   * Crea una instancia de Agent
   * @param {Object} config - Configuración del agente
   * @param {string} config.key - Identificador único del agente
   * @param {string} config.name - Nombre para mostrar del agente
   * @param {string} config.description - Descripción del agente
   * @param {string} config.icon - Nombre del ícono (de react-icons)
   * @param {string} [config.webhookEndpoint] - Endpoint del webhook para este agente (opcional)
   */
  constructor({ key, name, description, icon, webhookEndpoint = '' }) {
    this.key = key;
    this.name = name;
    this.description = description;
    this.icon = icon;
    this.webhookEndpoint = webhookEndpoint;
  }

  /**
   * Crea una instancia de Agent desde un objeto plano
   * @param {Object} data - Datos del agente
   * @returns {Agent} Instancia de Agent
   */
  static fromObject(data) {
    return new Agent({
      key: data.key,
      name: data.name,
      description: data.description,
      icon: data.icon,
      webhookEndpoint: data.webhookEndpoint,
    });
  }

  /**
   * Convierte la instancia a un objeto plano
   * @returns {Object} Objeto plano con las propiedades del agente
   */
  toObject() {
    return {
      key: this.key,
      name: this.name,
      description: this.description,
      icon: this.icon,
      webhookEndpoint: this.webhookEndpoint,
    };
  }
}

export default Agent;
